import { Tabs } from "@mui/material";
import { useStyles as useTabsStyles } from "components/Tabs/OLTabs.styles";
import { useMessage } from "hooks/intl";
import { Dispatch, SetStateAction } from "react";
import { DefaultLanguageDataState } from "reduxState/translations/translationsSlice";
import { TierDetailsType } from "types/tierSets";
import { TierTab } from "./TierTab";

interface Props {
  activeTier: number;
  setActiveTier: Dispatch<SetStateAction<number>>;
  tiers: TierDetailsType[];
  remove: (index: number) => void;
  defaultLang: DefaultLanguageDataState;
  errors: any;
}

export const TiersTabs = ({
  activeTier,
  tiers,
  defaultLang,
  setActiveTier,
  remove,
  errors,
}: Props) => {
  const tabClasses = useTabsStyles();
  const { message } = useMessage();

  return (
    <Tabs
      allowScrollButtonsMobile
      className={`${tabClasses.tabsContainer} ${tabClasses.scrollButton}`}
      scrollButtons
      value={activeTier}
      variant="scrollable"
    >
      {tiers.map((tier, index: number) => {
        const tierName =
          tier?.translations[defaultLang.code]?.name ||
          `${message({ id: "tier" }).toUpperCase()} #${index + 1}`;
        const areTierErrors =
          errors && !!(errors.tiers as { [key: number]: any })?.[`${index}`];
        const isSelected = activeTier === index;

        return (
          <TierTab
            key={index}
            isSelected={isSelected}
            areTierErrors={areTierErrors}
            index={index}
            tierName={tierName}
            setActiveTier={setActiveTier}
            remove={remove}
            activeTier={activeTier}
            isDefault={tier.isDefault}
          />
        );
      })}
    </Tabs>
  );
};
